import React from 'react';
import { useState } from 'react';
import image1bridal from '../assets/carousel/carousel-bridal-1.jpg'
import image2bridal from '../assets/carousel/carousel-bridal-2.jpg'
import image3bridal from '../assets/carousel/carousel-bridal-3.jpg'
import image4bridal from '../assets/carousel/carousel-bridal-4.jpg'
import image1hoverbridal from '../assets/carousel/carousel-bridal-hover-1.jpg'
import image2hoverbridal from '../assets/carousel/carousel-bridal-hover-2.jpg'
import image3hoverbridal from '../assets/carousel/carousel-bridal-hover-3.jpg'
import image4hoverbridal from '../assets/carousel/carousel-bridal-hover-4.jpg'
import image1night from '../assets/carousel/carousel-night-1.jpg'
import image2night from '../assets/carousel/carousel-night-2.jpg'
import image3night from '../assets/carousel/carousel-night-3.jpg'
import image4night from '../assets/carousel/carousel-night-4.jpg'
import image1hovernight from '../assets/carousel/carousel-night-hover-1.jpg'
import image2hovernight from '../assets/carousel/carousel-night-hover-2.jpg'
import image3hovernight from '../assets/carousel/carousel-night-hover-3.jpg'
import image4hovernight from '../assets/carousel/carousel-night-hover-4.jpg'

const ImageCrousel = () => {

  const [activeCategory, setActiveCategory] = useState("ΝΥΦΙΚΑ");

  const images ={ "ΝΥΦΙΚΑ":  [
    { default: image1bridal, hover: image1hoverbridal },
    { default: image2bridal, hover: image2hoverbridal },
    { default: image3bridal, hover: image3hoverbridal },
    { default: image4bridal, hover: image4hoverbridal },
   ],
   "ΒΡΑΔΙΝΑ":  [
    { default: image1night, hover: image1hovernight },
    { default: image2night, hover: image2hovernight },
    { default: image3night, hover: image3hovernight },
    { default: image4night, hover: image4hovernight },
   ],
  };
  return (
    <div className="py-16">
      {/* Top Navigation Links */}
      <div className="text-center mb-8">
        <nav className="space-x-8 text-2xl font-serif">
          <button
            onClick={() => setActiveCategory("ΝΥΦΙΚΑ")}
            className={`hover:underline ${activeCategory === "ΝΥΦΙΚΑ" ? "text-black" : "text-gray-500"}`}
          >
            ΝΥΦΙΚΑ
          </button>
          <button
            onClick={() => setActiveCategory("ΒΡΑΔΙΝΑ")}
            className={`hover:underline ${activeCategory === "ΒΡΑΔΙΝΑ" ? "text-black" : "text-gray-500"}`}
          >
            ΒΡΑΔΙΝΑ
          </button>
          {/* Add other categories here if needed */}
        </nav>
      </div>

      {/* Gallery Grid */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 px-4 md:px-8">
        {images[activeCategory].map((image, index) => (
          <div
            key={index}
            className="relative overflow-hidden rounded-md group"
          >
            {/* Default Image */}
            <img
              src={image.default}
              alt={`Gallery Image ${index + 1}`}
              className="w-full h-full object-cover transition-opacity duration-1000 group-hover:opacity-0"
            />
            {/* Hover Image */}
            <img
              src={image.hover}
              alt={`Gallery Hover Image ${index + 1}`}
              className="w-full h-full object-cover absolute inset-0 transition-opacity duration-1000 opacity-0 group-hover:opacity-100"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageCrousel;
